import type { RouteRecordRaw } from 'vue-router';
import { mdiCheckCircle } from '@mdi/js';

const i18n = import.meta.glob<{ default: Record<string, unknown> }>('./i18n/*.ts');

export const forgotPasswordSentRoutes = {
  name: 'forgot-password-sent',
  path: 'forgot-password-sent',
  components: {
    default: () => import('./ForgotPasswordSent.vue'),
    brand: () => import('./ForgotPasswordSentBrand.vue'),
  },
  meta: {
    i18n,
    // Xác nhận TRUNG TÍNH, chống dò email: không nhắc lại địa chỉ vừa nhập.
    authHeader: {
      titleKey: 'forgotPasswordSent.emailSentTitle',
      subtitleKey: 'forgotPasswordSent.emailSentHelper',
      icon: { name: mdiCheckCircle, tone: 'positive' },
      announce: 'status',
    },
  },
} satisfies RouteRecordRaw;
